<template>
  <div class="text-center">
    <v-dialog persistent v-if="visible" v-model="visible" width="400">
      <v-card class="not-margin pt-0 pr-0 pl-0">
        <v-toolbar dark color="primary">
          <div class="text-center">
            <v-icon>mdi-pencil</v-icon>
            {{ edit ? "Editar" : "Cadastrar" }} Turno
          </div>
        </v-toolbar>
        <div class="container dialog">
          <v-form ref="form">
            <v-row class="d-flex justify-center mt-7">
              <v-col cols="12">
                <v-text-field
                  label="Turno*"
                  v-model="content.descricao"
                  outlined
                  counter="25"
                  maxlength="25"
                  dense
                  :rules="[(v) => $required(v)]"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Hora de Início*"
                  v-model="content.horaInicio"
                  outlined
                  counter="5"
                  dense
                  v-mask="'##:##'"
                  :rules="[(v) => $required(v), (v) => horaValida(v)]"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  label="Hora de Término*"
                  v-model="content.horaFim"
                  outlined
                  counter="5"
                  dense
                  v-mask="'##:##'"
                  :rules="[(v) => $required(v), (v) => horaValida(v)]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
          <div class="mt-4">
            <v-icon color="warning" class="mr-2">mdi-alert-circle</v-icon>
            <span>Os campos marcados com asterisco(*) são obrigatórios.</span>
          </div>
        </div>
        <sca-buttons
          @click="salvar()"
          @cancel="$emit('onClose')"
          :actionText="edit ? 'Editar' : 'Salvar'"
        ></sca-buttons>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DialogProps } from '~/commons/classes/dialog-props';
import { Turno } from '~/commons/classes/turno';
import TurnoService from '~/services/turno.service';

export default {
  props: new DialogProps(Turno),
  mixins: [TurnoService],
  methods: {
    salvar() {
      const save = () => {
        return this.$swal({
          text: `Deseja ${this.edit ? "editar" : "cadastrar"} o registro?`,
          type: "warning",
          showCancelButton: true,
          confirmButtonText: `Confirmar`,
          cancelButtonText: `Cancelar`,
        }).then(() => {
          const turno = new Turno(this.content).format();
          return this.edit
            ? this.$editarTurno(turno.id, turno)
            : this.$cadastrarTurno(turno);
        });
      };
      if (this.$validarFormulario() && this.horaInicioAntesDoFim()) {
        save().then(({ data }) => {
          this.$notifySuccess(data.mensagem);
          this.$emit("onClose");
          this.$emit("onSave");
        });
      }
    },
    horaValida(h) {
      if (!h) return true;
      const [hora, minuto] = h.split(':').filter(h => h.length === 2).map(x => parseInt(x));
      if (isNaN(hora) || isNaN(minuto)) return 'Insira o horário no formato HH:MM';
      const condicao = hora >= 0 && hora <= 23 && minuto >= 0 && minuto <= 59;
      return condicao || 'Hora inválida';
    },
    horaInicioAntesDoFim() {
      const horaInicio = parseInt(this.content.horaInicio.replace(':', ''));
      const horaFim = parseInt(this.content.horaFim.replace(':', ''));
      const condicao = horaInicio < horaFim;
      if (!condicao) {
        this.$notifyWarning('A hora de início não pode ser maior que a hora de término. Verifique os campos preenchidos.');
      }
      return condicao;
    }
  },
};
</script>
